module.exports = __webpack_public_path__ + "img/ic_2.131d9580.png";